import React, { useRef } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import $ from "jquery";

const UpdateCompanyDetailsModal = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setRowAddData,
  rowAddData,
}) => {
  // console.log("selectedRowsData", selectedRowsData)
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  
  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const updateData = async (e) => {
    e.preventDefault();
    const { id, company_name, type, location } = selectedRowsData;
    let BASE_URL = SERVER_URL + `/api/company/company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        company_name,
        type,
        location,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      getData();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
      getData();
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Company
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Company</h4> */}
                    <form className="form-sample" onSubmit={updateData}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Company_Name">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              id="Company_Name"
                              placeholder="Company Name"
                              onChange={updateHandleChange}
                              value={selectedRowsData?.company_name}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="type">Type</label>
                            <input
                              type="text"
                              className="form-control"
                              name="type"
                              id="type"
                              placeholder="Type"
                              onChange={updateHandleChange}
                              value={selectedRowsData?.type}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Location">Location</label>
                            <input
                              type="text"
                              className="form-control"
                              name="location"
                              id="Location"
                              placeholder="Location"
                              onChange={updateHandleChange}
                              value={selectedRowsData?.location}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateData}
                      >
                        Update
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateCompanyDetailsModal;
